<template>
  <div class="trip-vis"></div>
</template>

<script>
import { Visualization } from 'trip-vis'
import { isEmpty, isArray, isString } from 'oderon-commons/src/utils'
import 'trip-vis/src/index.sass'

export default {
  props: {
    sel: {},
    tripData: { type: Object }
  },
  watch: {
    tripData() {
      this.redraw()
    },
    sel() {
      this.doSelection()
    }
  },
  mounted() {
    this.redraw()
  },
  destroyed() {
    this.vis && this.vis.destroy()
  },
  methods: {
    redraw() {
      // limpa a vis anterior, se existia
      this.vis && this.vis.destroy()

      if (this.tripData != null) {
        this.vis = new Visualization({
          data: this.tripData,
          $rootDiv: this.$el
        })

        this.vis.redraw()

        this.vis.events.on('chart-resize', evt => {
          this.$emit('chartResize', evt)
        })

        this.doSelection()
      }
    },

    doSelection() {
      let x = this.sel
      if (isEmpty(x)) return null

      // Um array sempre vai selecionar um range. Observe
      // que pode ser array de Number, de String, ou Moment/Date.
      if (isArray(x)) return this.vis.selectRange(x)

      // Se é uma string, pode ser um timestamp, ou um range
      // de timestamps separado por ".."
      if (isString(x)) {
        let pieces = x.split('..')
        if (pieces.length == 2) return this.vis.selectRange(pieces)
        else return this.vis.selectTimestamp(x)
      }

      // Se é um número ou um Moment/Date, tenta selecionar
      // diretamente.
      return this.vis.selectTimestamp(x)
    }
  }
}
</script>

<style>
.trip-vis {
  width: 100%;
  height: 100%;
}
</style>
